import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';
import useMarketingFonts from '../marketing/useMarketingFonts';
import useSeoHead from '../marketing/useSeoHead';
import MarketingNav from '../marketing/components/MarketingNav';
import MarketingFooter from '../marketing/components/MarketingFooter';
import SimplePageHero from '../marketing/components/SimplePageHero';
import { marketingColors as C, marketingFonts as F } from '../theme_landing_page';

interface ComingSoonPageProps {
  eyebrow: string;
  title: React.ReactNode;
  description: string;
  canonicalPath: string;
}

/**
 * Placeholder for a page that exists in the MillOS rebrand's nav/footer but hasn't been built
 * yet (the rebrand was scoped to Nav + Footer + Home first — see CHANGELOG). Keeps every link
 * live instead of 404ing while the remaining pages are converted in follow-up passes.
 */
const ComingSoonPage: React.FC<ComingSoonPageProps> = ({ eyebrow, title, description, canonicalPath }) => {
  useMarketingFonts();
  useSeoHead({ title: `${eyebrow} | MillOS`, description, canonicalPath });

  return (
    <Box className="lv-marketing" sx={{ background: C.white, color: C.ink, fontFamily: F.body, fontSize: 16, lineHeight: 1.5, overflowX: 'hidden' }}>
      <MarketingNav />
      <SimplePageHero eyebrow={eyebrow} title={title} body={description} bottomPadding="96px" />
      <Box sx={{ maxWidth: 1000, margin: '0 auto', padding: '0 24px 120px', textAlign: 'center' }}>
        <Box sx={{ background: C.mist, border: `1px solid ${C.glassBorder}`, borderRadius: '24px', padding: '48px 32px' }}>
          <Box sx={{ fontFamily: F.display, fontSize: 24, color: C.ink }}>This page is coming soon</Box>
          <Box sx={{ marginTop: '12px', color: C.body, fontSize: 15 }}>We're still building this one out. In the meantime, take a look around the rest of MillOS.</Box>
          <Box
            component={RouterLink}
            to="/"
            sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: C.millosMint, color: C.navy, fontWeight: 600, borderRadius: '32px', padding: '12px 22px', fontSize: 15, marginTop: '24px', '&:hover': { background: '#1B46C4', color: C.white } }}
          >
            Back to home
          </Box>
        </Box>
      </Box>
      <MarketingFooter />
    </Box>
  );
};

export default ComingSoonPage;
